import { i18n } from "../../config/i18n"
import type { Language } from "."

export const setLanguage: Language.Functions.SetLanguage = ({ locale }) => {
  i18n.locale = locale
  window.history.pushState({}, "", `/${locale}`)
}
